// extracted by mini-css-extract-plugin
module.exports = {"trackerContainer":"Tracker_trackerContainer__JTyIT","slideButtons":"Tracker_slideButtons__3tla_","foods":"Tracker_foods__3uMAH","food":"Tracker_food__gO5Gj"};